import { StudiesPage } from "@/features/studies/components/StudiesPage";
import { studiesQueryOptions } from "@/features/studies/api/selectStudies";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/studies/")({
    component: StudiesPage,
    loader: async ({ context }) => {
        const isAdmin = context.auth?.roles?.isAdmin || context.auth?.isSuperUser;
        await context.queryClient.ensureQueryData(studiesQueryOptions(context.auth.id, isAdmin));
    },
});
